(async () => {
  const root = document.querySelector('[data-native-design-studio]');
  if (!root) return;
  const isOperator = root.hasAttribute('data-set-composer');
  if (isOperator) document.title = '套装编排工作台 · FLORALSCULPT 运营';
  const frame = root.querySelector('[data-native-studio-frame]');
  const workspace = root.querySelector('.design-studio-workspace');
  const studioLoader = root.querySelector('[data-native-studio-loader]');
  const studioLoaderCopy = root.querySelector('[data-native-studio-loader-copy]');
  const studioRetry = root.querySelector('[data-native-studio-retry]');
  const backLink = root.querySelector('[data-studio-back]');
  const setsNode = document.querySelector('[data-native-studio-sets]');
  const pageParams = new URLSearchParams(location.search);
  const assistant = root.querySelector('[data-studio-assistant]');
  const assistantPanel = root.querySelector('[data-assistant-panel]');
  const assistantBody = root.querySelector('[data-assistant-body]');
  const assistantProgress = root.querySelector('[data-assistant-progress]');
  const assistantInput = root.querySelector('[data-assistant-input]');
  const assistantSend = root.querySelector('[data-assistant-send]');
  const assistantStopResponse = root.querySelector('[data-assistant-stop-response]');
  const assistantApiEndpoint = root.dataset.assistantApiEndpoint || '';
  const onboarding = root.querySelector('[data-studio-onboarding]');
  const safeReturnUrl = value => {
    if (!value) return null;
    try {
      const candidate = new URL(value, location.origin);
      if (candidate.origin !== location.origin) return null;
      if (candidate.pathname === location.pathname && candidate.searchParams.get('view') === 'design-studio') return null;
      return `${candidate.pathname}${candidate.search}${candidate.hash}`;
    } catch (_) {
      return null;
    }
  };
  const returnUrl = safeReturnUrl(pageParams.get('return_to')) || safeReturnUrl(document.referrer);
  if (!isOperator && backLink && returnUrl) backLink.href = returnUrl;
  const showInvalidPlan = text => {
    if (studioLoaderCopy) studioLoaderCopy.textContent = text;
    if (studioRetry) {
      studioRetry.textContent = 'Back to shop';
      studioRetry.hidden = false;
      studioRetry.addEventListener('click', () => location.assign(returnUrl || '/collections/all'), { once:true });
    }
  };
  const aiPlanParam = pageParams.get('ai_plan');
  let requestedAiPlan = null;
  if (aiPlanParam !== null) {
    try {
      if (aiPlanParam.length <= 2000) requestedAiPlan = JSON.parse(aiPlanParam);
    } catch (_) {}
    if (requestedAiPlan?.version !== 1 || !Array.isArray(requestedAiPlan.lines) || !requestedAiPlan.lines.length || requestedAiPlan.lines.length > 4) {
      showInvalidPlan('This recommendation link is incomplete. Return to Studio Assistant and choose the pieces again.');
      return;
    }
  }
  const staticMaterials = {
    p01:'mat-camellia',p02:'mat-peony',p03:'mat-hydrangea',p04:'mat-rose',p05:'mat-sunflower',p06:'mat-lisianthus',p07:'mat-phalaenopsis',p08:'mat-carnation',
    p09:'mat-pussy-willow',p10:'mat-branch',p11:'mat-nandina',p12:'mat-eucalyptus',p13:'mat-olive',p14:'mat-fern',p15:'mat-dusty-miller',
    p22:'mat-vase-glass',p23:'mat-vase-ink',p24:'mat-vase-neck',p25:'mat-vase-wabi',p26:'mat-vase-ceramic',p29:'mat-vase-basket',p30:'mat-vase-glass',p31:'mat-vase-neck'
  };
  let starterSets = [];
  try { starterSets = JSON.parse(setsNode?.textContent || '[]'); } catch (_) {}
  const finishedSetIds = new Set(starterSets.filter(set => set?.recipe?.set_type === 'finished').map(set => String(set.recipe.id)));
  starterSets = starterSets.filter(set => set?.recipe?.set_type !== 'finished');
  try {
    const storedSetSeed = JSON.parse(sessionStorage.getItem('floralsculpt_studio_set_seed_v1') || 'null');
    const requestedSetId = pageParams.get('set');
    if (storedSetSeed?.recipe?.id && storedSetSeed.recipe.set_type !== 'finished' && (!requestedSetId || String(storedSetSeed.recipe.id) === String(requestedSetId))) {
      starterSets = [
        storedSetSeed,
        ...starterSets.filter(set => String(set?.recipe?.id || '') !== String(storedSetSeed.recipe.id))
      ];
    }
  } catch (_) {}

  const hasAiPlanRequest = requestedAiPlan !== null;
  const newSessionId = () => `native-${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
  let sessionId = newSessionId();
  const asset = frame.dataset.studioAsset;
  const url = new URL(asset, document.baseURI);
  const studioParams = new URLSearchParams({embed:'1',revision:'34',session_id:sessionId,parent_origin:location.origin});
  if (frame.dataset.studioBodyFontUrl) studioParams.set('body_font_url', frame.dataset.studioBodyFontUrl);
  if (frame.dataset.studioNumeralFontUrl) studioParams.set('numeral_font_url', frame.dataset.studioNumeralFontUrl);
  if (isOperator) studioParams.set('operator', '1');
  if (isOperator && root.dataset.composerDisplayVase === 'true') studioParams.set('display_vase', '1');
  ['source','product','product_id','variant','vase'].forEach(key => {
    if (pageParams.get(key)) studioParams.set(key, pageParams.get(key));
  });
  const legacyLookSet = {'soft-morning-dining':'soft-morning-live'}[pageParams.get('look')];
  const explicitSet = pageParams.get('set') || legacyLookSet;
  const hasProductSeed = ['product','product_id','variant','vase'].some(key => Boolean(pageParams.get(key)));
  const defaultSet = !explicitSet
    && !pageParams.get('look')
    && !hasProductSeed
    && !hasAiPlanRequest
    && !isOperator
    ? starterSets.find(set => set?.recipe?.id)?.recipe?.id
    : null;
  const requestedSet = (explicitSet && !finishedSetIds.has(String(explicitSet)) ? explicitSet : null) || defaultSet;
  if (requestedSet) studioParams.set('set', requestedSet);
  else if (pageParams.get('look')) studioParams.set('look', pageParams.get('look'));
  url.hash = studioParams.toString();

  let studioReady = false;
  let catalogReady = false;
  let catalogSent = false;
  let messageHandlerReady = false;
  let earlyRendered = false;
  let studioBootTimer = 0;
  let selection = {vase:null,items:[]};
  let seq = -1;
  let operatorEntry = 0;
  let operatorMode = '';
  let operatorSeedSetId = '';
  const postToStudio = message => frame.contentWindow?.postMessage({version:2,session_id:sessionId,...message}, '*');
  const sendCatalogIfReady = () => {
    if (!studioReady || !catalogReady || !messageHandlerReady || catalogSent) return false;
    catalogSent = true;
    postToStudio({type:'floree:studio-catalog',products:catalog,sets:starterSets});
    return true;
  };
  const captureEarlyStudioReady = event => {
    if (event.source !== frame.contentWindow) return;
    const message = event.data || {};
    if (message.version !== 2 || message.session_id !== sessionId) return;
    if (message.type === 'floree:studio-rendered') {
      earlyRendered = true;
    } else if (message.type === 'floree:studio-ready') {
      studioReady = true;
      sendCatalogIfReady();
    }
  };
  window.addEventListener('message', captureEarlyStudioReady);
  frame.addEventListener('load', () => {
    root.classList.remove('is-studio-modal-open');
  });
  const loadOperatorStudio = (mode, retry = false, seedSetId = '') => {
    operatorMode = mode;
    operatorSeedSetId = mode === 'diy' ? seedSetId : '';
    sessionId = newSessionId();
    studioReady = false;
    catalogSent = false;
    earlyRendered = false;
    seq = -1;
    selection = {vase:null,items:[]};
    root.floralsculptStudioSelection = null;
    const nextUrl = new URL(url.href);
    // A query change forces a new document; changing only the hash keeps the old canvas running.
    nextUrl.searchParams.set('composer_entry', String(++operatorEntry));
    const nextParams = new URLSearchParams(nextUrl.hash.slice(1));
    ['source','product','product_id','variant','vase','set','look'].forEach(key => nextParams.delete(key));
    nextParams.set('session_id', sessionId);
    if (operatorSeedSetId) nextParams.set('set', operatorSeedSetId);
    if (mode === 'finished') nextParams.set('finished', '1');
    else nextParams.delete('finished');
    nextUrl.hash = nextParams.toString();
    workspace?.classList.remove('is-studio-ready');
    studioLoader?.setAttribute('aria-hidden', 'false');
    if (studioLoaderCopy) studioLoaderCopy.textContent = retry ? '正在重新载入编排工作台…' : '正在载入编排工作台…';
    if (studioRetry) studioRetry.hidden = true;
    window.clearTimeout(studioBootTimer);
    studioBootTimer = window.setTimeout(() => {
      if (workspace?.classList.contains('is-studio-ready')) return;
      if (studioLoaderCopy) studioLoaderCopy.textContent = '编排工作台载入时间较长';
      if (studioRetry) studioRetry.hidden = false;
    }, 12000);
    frame.src = nextUrl.href;
  };
  // Operator editors open only after session verification and a mode choice.
  if (isOperator) {
    root.addEventListener('floralsculpt:composer-mode', event => {
      const mode = event.detail?.mode;
      if (!['diy', 'finished'].includes(mode)) return;
      loadOperatorStudio(mode, false, String(event.detail?.seedSetId || ''));
    });
  } else {
    frame.src = url.href;
  }

  let catalog = [];
  try {
    const { readCatalogPage, loadCompleteCatalog } = await import(root.dataset.catalogLoaderUrl);
    const endpoint = new URL(root.dataset.productsCollectionUrl, location.origin);
    endpoint.searchParams.set('section_id', 'studio-catalog-page');
    // Keep the current draft and locale, but never inherit unrelated UI filters.
    if (pageParams.has('preview_theme_id')) endpoint.searchParams.set('preview_theme_id', pageParams.get('preview_theme_id'));
    const initial = readCatalogPage(document);
    catalog = await loadCompleteCatalog({
      initial,
      endpoint,
      fetchPage: async pageUrl => {
        const response = await fetch(pageUrl, { credentials: 'same-origin', signal: AbortSignal.timeout(15000) });
        if (!response.ok) throw new Error('Catalogue request failed');
        return readCatalogPage(new DOMParser().parseFromString(await response.text(), 'text/html'));
      },
      onProgress: (loaded, total) => {
        if (studioLoaderCopy) studioLoaderCopy.textContent = isOperator
          ? `正在载入完整素材库…（${loaded}/${total}）`
          : `Loading your material library… (${loaded}/${total})`;
      }
    });
  } catch (error) {
    console.error('Studio catalogue could not finish loading', error);
    if (studioLoaderCopy) studioLoaderCopy.textContent = isOperator
      ? '素材库未完整载入，请重试。'
      : 'Your material library could not finish loading. Please try again.';
    if (studioRetry) {
      studioRetry.hidden = false;
      studioRetry.addEventListener('click', () => location.reload(), { once: true });
    }
    return;
  }
  catalog = catalog.filter(Boolean).map(record => {
    record.material_id = staticMaterials[record.product_id] || record.material_id;
    const variantCutouts = record.variant_cutouts || {};
    record.variants = (record.variants || []).map(variant => {
      const variantCutout = variantCutouts[String(variant.id)] || null;
      return {
        id: String(variant.id),
        title: variant.title || 'Default Title',
        option1: variant.option1 || null,
        options: variant.options || [],
        available: Boolean(variant.available),
        price_minor: Number(variant.price || 0),
        compare_at_price_minor: Number(variant.compare_at_price || 0),
        cutout: variantCutout,
        image: variantCutout || variant.featured_image?.src || variant.featured_media?.preview_image?.src || null
      };
    });
    record.status = record.variants.some(variant => variant.available) ? 'available' : 'unavailable';
    return record;
  });
  const byProduct = new Map(catalog.map(record => [record.product_id, record]));
  const byMaterial = new Map(catalog.map(record => [record.material_id, record]));
  const byHandle = new Map(catalog.map(record => [record.handle, record]));
  catalogReady = true;
  root.floralsculptStudioCatalog = catalog;
  root.dispatchEvent(new CustomEvent('floralsculpt:studio-catalog-ready', {detail:catalog}));
  const normalizeAssistantPlan = plan => {
    const normalized = [];
    for (const line of Array.isArray(plan?.lines) ? plan.lines : []) {
      const sourceRecord = line?.record || {};
      const record = byHandle.get(String(line?.handle || sourceRecord.handle || ''))
        || byProduct.get(String(line?.product_id || sourceRecord.product_id || ''))
        || byMaterial.get(String(line?.material_id || sourceRecord.material_id || ''));
      if (!record?.material_id) return null;
      const isVase = record.category === 'vase';
      const existing = normalized.find(item => item.record === record);
      if (existing) {
        if (!isVase) existing.quantity = Math.min(12, existing.quantity + Math.max(1, Math.round(Number(line?.quantity || 1))));
        continue;
      }
      if (isVase && normalized.some(item => item.isVase)) continue;
      if (!isVase && normalized.filter(item => !item.isVase).length >= 3) continue;
      normalized.push({record,quantity:isVase ? 1 : Math.max(1, Math.min(12, Math.round(Number(line?.quantity || 1)))),isVase});
    }
    if (!normalized.length) return null;
    return {
      id:String(plan?.id || `ai-plan-${Date.now()}`),
      layoutIndex:Math.max(0, Math.min(2, Math.round(Number(plan?.layoutIndex || 0)))),
      name:String(plan?.name || 'AI recommended pieces').slice(0, 100),
      summary:String(plan?.summary || plan?.rationale || 'Selected from currently available Studio materials.').slice(0, 300),
      lines:[...normalized.filter(line => line.isVase),...normalized.filter(line => !line.isVase)]
    };
  };
  const aiPlanSeed = hasAiPlanRequest ? normalizeAssistantPlan(requestedAiPlan) : null;
  if (hasAiPlanRequest && !aiPlanSeed) {
    showInvalidPlan('One or more recommended products are no longer in the current catalog. Please choose again from Studio Assistant.');
    return;
  }
  const seededProductRecord = pageParams.get('source') === 'native_product'
    ? catalog.find(record => String(record.product_id) === String(pageParams.get('product_id') || '') || record.handle === pageParams.get('product'))
    : null;
  const seededProductIsVase = seededProductRecord?.category === 'vase';
  const seededNextCategory = seededProductIsVase ? 'flower' : 'vase';
  if (!isOperator) studioBootTimer = window.setTimeout(() => {
    if (workspace?.classList.contains('is-studio-ready')) return;
    if (studioLoaderCopy) studioLoaderCopy.textContent = 'The studio is taking longer than expected';
    if (studioRetry) studioRetry.hidden = false;
  }, 12000);
  const markStudioRendered = () => {
    window.clearTimeout(studioBootTimer);
    workspace?.classList.add('is-studio-ready');
    if (studioLoader) studioLoader.setAttribute('aria-hidden', 'true');
  };
  studioRetry?.addEventListener('click', () => {
    if (isOperator && operatorMode) {
      loadOperatorStudio(operatorMode, true, operatorSeedSetId);
      return;
    }
    workspace?.classList.remove('is-studio-ready');
    if (studioLoader) studioLoader.setAttribute('aria-hidden', 'false');
    if (studioRetry) studioRetry.hidden = true;
    if (studioLoaderCopy) studioLoaderCopy.textContent = isOperator ? '正在重新载入编排工作台…' : 'Reloading your design studio…';
    const retryUrl = new URL(frame.src);
    const retryParams = new URLSearchParams(retryUrl.hash.replace(/^#/, ''));
    retryParams.set('reload', Date.now().toString(36));
    retryUrl.hash = retryParams.toString();
    studioReady = false;
    catalogSent = false;
    studioBootTimer = window.setTimeout(() => {
      if (studioLoaderCopy) studioLoaderCopy.textContent = isOperator ? '编排工作台仍未完成载入' : 'The studio could not finish loading';
      if (studioRetry) studioRetry.hidden = false;
    }, 12000);
    frame.src = retryUrl.href;
  });
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:window.theme?.currency || 'USD'}).format(Number(cents || 0) / 100);
  const productFor = line => byProduct.get(line.product_id) || byMaterial.get(line.material_id);
  const variantFor = (record,line) => record?.variants.find(variant => String(variant.id) === String(line.shopify_variant_id || ''))
    || record?.variants.find(variant => [variant.title,variant.option1,...variant.options].some(value => String(value || '').toLowerCase() === String(line.variant_key || '').toLowerCase()))
    || record?.variants.find(variant => variant.available) || record?.variants[0];
  const lines = () => [...(selection.vase?.display_only === true ? [] : [selection.vase]),...(selection.items || [])].filter(Boolean).map(line => {
    const product = productFor(line), variant = variantFor(product,line), quantity = Math.max(1,Number(line.quantity || 1));
    return {...line,product,variant,quantity,isVase:line === selection.vase,lineTotal:Number(variant?.price_minor || 0) * quantity};
  });
  const send = postToStudio;
  root.addEventListener('floralsculpt:studio-command', event => {
    const command = event.detail;
    if (!command || typeof command.type !== 'string') return;
    send(command);
  });
  let pendingStudioCategory = seededProductRecord ? seededNextCategory : null;
  const focusStudioCategory = category => {
    pendingStudioCategory = category;
    send({type:'floree:studio-focus-category',category});
  };
  const setOnboardingOpen = open => {
    if (!onboarding) return;
    onboarding.hidden = !open;
    onboarding.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (open) onboarding.querySelector('[data-studio-start-vase]')?.focus({preventScroll:true});
  };
  const closeOnboarding = () => setOnboardingOpen(false);
  const escapeHTML = value => String(value ?? '').replace(/[&<>'"]/g, character => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[character]));
  const seedProductLabel = seededProductIsVase ? 'vase' : seededProductRecord?.category === 'line' ? 'branch' : seededProductRecord?.category === 'greenery' ? 'greenery' : 'flower';
  const assistantAvatar = '<span class="studio-assistant__avatar" aria-hidden="true"><svg viewBox="0 0 32 32" fill="none"><path d="M16 5.5c3.2 0 5.1 2 5.1 5.1 3.1 0 5.1 1.9 5.1 5.1 0 3.2-2 5.1-5.1 5.1 0 3.1-1.9 5.1-5.1 5.1-3.2 0-5.1-2-5.1-5.1-3.1 0-5.1-1.9-5.1-5.1 0-3.2 2-5.1 5.1-5.1 0-3.1 1.9-5.1 5.1-5.1Z" stroke="currentColor" stroke-width="1.4"/><circle cx="16" cy="16" r="2.4" fill="currentColor"/></svg><span class="studio-assistant__signal-meter"><b></b><b></b><b></b><b></b><b></b></span></span>';
  const assistantQuestions = [
    {key:'space',eyebrow:'Placement',title:'Where will it live?',copy:'The room tells us the right height, footprint and viewing angle.',choices:[
      {value:'dining',label:'Dining table',copy:'Low enough for conversation, generous from every side.'},
      {value:'console',label:'Console or entryway',copy:'More height and a clear silhouette from the front.'},
      {value:'shelf',label:'Shelf or bedside',copy:'Compact, calm and considered at close range.'}
    ]},
    {key:'mood',eyebrow:'Mood',title:'What should the room feel like?',copy:'Choose the atmosphere; every suggestion remains fully editable.',choices:[
      {value:'airy',label:'Airy and light',copy:'Ivory blooms, soft greens and visual breathing room.'},
      {value:'sculptural',label:'Sculptural',copy:'Branches, stronger lines and an asymmetric outline.'},
      {value:'soft',label:'Soft colour',copy:'A measured touch of blush, coral or muted bloom.'}
    ]},
    {key:'scale',eyebrow:'Scale',title:'How much presence do you want?',copy:'We will adjust the number of stems and the balance of structure to softness.',choices:[
      {value:'compact',label:'Quiet accent',copy:'A focused arrangement for a smaller surface.'},
      {value:'balanced',label:'Balanced',copy:'Enough presence to anchor a room without taking over.'},
      {value:'statement',label:'Statement',copy:'Taller, fuller and intentionally dramatic.'}
    ]}
  ];
  let assistantStep = 0;
  let assistantAnswers = {};
  let assistantPlans = [];
  let pendingAssistantPlan = null;
  let assistantBusy = false;
  let assistantTimer = 0;
  let assistantRequestController = null;
  let assistantFreeText = null;
  let assistantConversation = [];
  let assistantConversationSequence = Date.now();

  const setAssistantOpen = open => {
    assistant.classList.toggle('is-open', open);
    assistant.setAttribute('aria-hidden', String(!open));
    const layout = root.querySelector('.design-studio-layout');
    if (layout) layout.inert = open;
    if (open) window.setTimeout(() => assistantPanel?.focus(), 60);
  };

  const syncAssistantComposer = () => {
    assistant.classList.toggle('is-thinking', assistantBusy);
    assistantInput.disabled = assistantBusy;
    assistantSend.hidden = assistantBusy;
    assistantStopResponse.hidden = !assistantBusy;
  };

  const firstUnansweredStep = () => assistantQuestions.findIndex(question => !assistantAnswers[question.key]);

  const parseAssistantLanguage = value => {
    const text = String(value || '').trim();
    const normalized = text.toLowerCase();
    const chinese = /[\u3400-\u9fff]/.test(text);
    const matches = (terms) => terms.some(term => normalized.includes(term));
    const understood = [];
    const recognizedKeys = [];
    const details = {};
    if (matches(['dining','dinner table','kitchen table','餐桌','餐厅'])) { details.space = 'dining'; understood.push(chinese ? '餐桌' : 'Dining table'); recognizedKeys.push('space'); }
    else if (matches(['console','entryway','entry way','foyer','hallway','玄关','边柜'])) { details.space = 'console'; understood.push(chinese ? '玄关或边柜' : 'Console or entryway'); recognizedKeys.push('space'); }
    else if (matches(['shelf','mantel','bedside','nightstand','bookcase','书架','床头','壁炉'])) { details.space = 'shelf'; understood.push(chinese ? '书架或床头' : 'Shelf or bedside'); recognizedKeys.push('space'); }
    if (matches(['airy','light','ivory','white','minimal','清爽','轻盈','白色'])) { details.mood = 'airy'; understood.push(chinese ? '轻盈通透' : 'Airy and light'); recognizedKeys.push('mood'); }
    else if (matches(['sculptural','branch','asymmetric','asymmetrical','architectural','雕塑','枝条','不对称'])) { details.mood = 'sculptural'; understood.push(chinese ? '雕塑线条感' : 'Sculptural'); recognizedKeys.push('mood'); }
    else if (matches(['soft colour','soft color','blush','pink','coral','romantic','柔和','粉色','暖色'])) { details.mood = 'soft'; understood.push(chinese ? '柔和色彩' : 'Soft colour'); recognizedKeys.push('mood'); }
    if (matches(['compact','small','subtle','quiet','not too full','not too large','小型','小一点','不要太满','低调'])) { details.scale = 'compact'; understood.push(chinese ? '克制小巧' : 'Quiet accent'); recognizedKeys.push('scale'); }
    else if (matches(['statement','large','full','dramatic','bold','饱满','大型','大一点','大一些','大的','醒目'])) { details.scale = 'statement'; understood.push(chinese ? '醒目大体量' : 'Statement'); recognizedKeys.push('scale'); }
    else if (matches(['balanced','medium','moderate','not too much','适中','平衡','中等'])) { details.scale = 'balanced'; understood.push(chinese ? '平衡适中' : 'Balanced'); recognizedKeys.push('scale'); }
    return {text,normalized,understood,recognizedKeys,details,chinese};
  };

  const wantsAssistantArrangement = normalized => /build.{0,28}(arrangement|set|bouquet)|create.{0,28}(arrangement|set|bouquet)|design.{0,28}(arrangement|set|bouquet)|complete arrangement|full set|arrangement for me|put together.{0,24}(arrangement|set)|帮我搭|搭一套|配一套|做一套|生成.{0,10}(方案|搭配|花艺)|设计.{0,10}(花艺|搭配|方案)|完整(方案|搭配|花艺)|整套/.test(normalized);
  const looksLikeAssistantQuestion = normalized => /[?？]|\b(who|what|which|how|why|when|where|can|could|should|would|does|do|is|are)\b|你是谁|能做什么|怎么|如何|什么|哪|适合|多少|多高|几支|是否|可以吗|能不能/.test(normalized);

  const assistantKnowledgeResponse = parsed => {
    const normalized = parsed.normalized;
    const chinese = parsed.chinese;
    if (/who are you|what are you|what can you do|你是谁|你能做什么|介绍.{0,4}自己/.test(normalized)) return {
      reply: chinese ? '我是 FLORALSCULPT 的 AI 花艺师。我可以直接回答花材搭配、花瓶比例、空间布置和养护问题，也可以从店铺现有商品中整理完整方案，再送进 Design Studio 继续编辑。只有当你明确想要方案时，我才会询问空间、风格和尺寸。' : 'I’m FLORALSCULPT’s AI florist. I can answer questions about flower pairings, vase proportion, styling and care, or shape complete options from current store pieces and send one into the Design Studio. I only ask about placement, mood and scale when you want a recommendation.',
      cta: chinese ? '让你帮我搭一套' : 'Build an arrangement with me'
    };
    if (/rose|玫瑰/.test(normalized)) return {
      reply: chinese ? '玫瑰可以走三种方向：搭配绣球、洋桔梗和轻绿植会更自然通透；搭配牡丹或浅色小花会更柔和浪漫；加入枝条和结构型绿植则更有线条感。不要让所有花头一样饱满，保留高低与空隙会更自然。' : 'Roses work in three useful directions. Add hydrangea, lisianthus and light greenery for an airy result; use peony or softer blooms for a romantic mood; or add branches and structured greenery for a more sculptural line. Vary the height and leave breathing room so every bloom does not feel equally full.',
      cta: chinese ? '用玫瑰生成搭配' : 'Create with roses'
    };
    if (/hydrangea|绣球/.test(normalized)) return {
      reply: chinese ? '绣球体量较大，适合作为视觉主体或柔和的体积层。可以搭配玫瑰、牡丹或玉兰，再用一两支绿植拉开轮廓。窄口花瓶不需要太多支，宽口花器则要增加枝叶结构来支撑。' : 'Hydrangea has strong visual volume, so it works well as a focal bloom or soft mass. Pair it with roses, peony or magnolia, then use one or two greenery stems to open the silhouette. A narrow vase needs fewer stems; a wide vessel needs more supporting structure.',
      cta: chinese ? '用绣球生成搭配' : 'Create with hydrangea'
    };
    if (/magnolia|玉兰/.test(normalized)) return {
      reply: chinese ? '玉兰本身线条感很强，适合少量成组使用。可以搭配橄榄枝、尤加利或较轻的白色花材，不要加入太多同样大型的主花。高挑花瓶适合保留枝条走势，低花器则适合剪短后做横向结构。' : 'Magnolia already has a strong line, so it is most effective in a restrained group. Pair it with olive, eucalyptus or lighter white blooms instead of several competing focal flowers. Keep the branch length in a tall vase, or cut it lower for a wider composition.',
      cta: chinese ? '用玉兰生成搭配' : 'Create with magnolia'
    };
    if (/vase|opening|花瓶|花器|瓶口|多高/.test(normalized)) return {
      reply: chinese ? '先看摆放位置和视线。餐桌花艺应以不遮挡交流为先，通常选择低矮或宽口花器；玄关可以更高、更有结构；床头和书架适合小型窄口花瓶。花瓶越宽，越需要枝叶结构支撑轮廓，而不是单纯增加主花数量。' : 'Start with placement and sightlines. Dining tables usually suit lower or wider vessels that keep conversation open; consoles can take more height and structure; shelves and bedside tables work best with compact narrow-opening vases. The wider the vessel, the more supporting structure it needs rather than simply more focal blooms.',
      cta: chinese ? '按这个比例生成搭配' : 'Build to these proportions'
    };
    if (/care|clean|dust|保养|清洁|打理|灰尘/.test(normalized)) return {
      reply: chinese ? '仿真花日常可以用柔软干布、软毛刷或低档冷风除尘，避免浸水和长时间阳光直射。整理时从枝条底部托住再调整角度，可以减少花头和连接处受力。' : 'Use a soft dry cloth, a soft brush or cool low-power air to remove dust from faux florals. Avoid soaking and prolonged direct sunlight. Support the stem near its base before adjusting the angle so the bloom and joins are not strained.'
    };
    if (/how many|number of stems|stem count|多少支|几支|数量/.test(normalized)) return {
      reply: chinese ? '数量取决于花瓶口径和想要的留白。窄口小花瓶可以从 3 至 5 支开始，中型花器通常先用 1 至 3 支主花，再加入结构枝和绿植。先建立轮廓，再补体量，比一次塞满更容易控制。' : 'Stem count depends on the vase opening and how much negative space you want. Start a narrow small vase with 3 to 5 stems. For a medium vessel, begin with 1 to 3 focal blooms, then add line and greenery. Build the silhouette first and add volume only where it is needed.'
    };
    if (/warm|uncluttered|not cluttered|温暖|不杂乱|克制|干净/.test(normalized)) return {
      reply: chinese ? '想要温暖但不杂乱，可以把颜色控制在米白、柔和杏色和少量焦糖棕，主花只保留一种，再用细枝和低饱和绿植拉开层次。花材集中在一个明确轮廓里，桌面留出足够负空间，效果会更克制。' : 'For warmth without clutter, keep the palette to ivory, soft apricot and a small amount of caramel brown. Use one focal flower, then create depth with fine branches and muted greenery. Hold everything within one clear silhouette and preserve negative space around it.',
      cta: chinese ? '生成温暖克制的方案' : 'Create this warm direction'
    };
    if (/pair|go with|搭配|配什么/.test(normalized)) return {
      reply: chinese ? '可以直接告诉我一种花材或花瓶，我会从色彩、体量和线条三个方面说明适合搭配什么，以及哪些组合容易显得拥挤。' : 'Tell me a flower or vase and I’ll explain what pairs with it through colour, visual volume and line, including which combinations are likely to feel crowded.'
    };
    return null;
  };

  const renderAssistantPaused = () => {
    assistantProgress.style.setProperty('--assistant-progress', '72%');
    assistantBody.innerHTML = `<div class="studio-assistant__paused">${assistantAvatar}<div><p>Analysis stopped.</p><h2>Your answers are still here.</h2><span>Type another instruction, resume the recommendations, or end the chat.</span><button type="button" data-assistant-resume>Resume recommendations</button></div></div>`;
  };

  const renderAssistantNaturalThinking = (parsed, mode = 'consultation') => {
    assistantProgress.style.setProperty('--assistant-progress', mode === 'recommendation' ? '58%' : '22%');
    const thinkingCopy = mode === 'recommendation'
      ? (parsed.chinese ? '我正在整理你已经给出的偏好，只补问真正影响方案的信息。' : 'I’m connecting the details you already gave me and checking what still changes the recommendation.')
      : (parsed.chinese ? '我正在理解你的问题。' : 'I’m considering your question.');
    const thinkingLabel = parsed.chinese ? '理解你的需求' : 'Reading your request';
    assistantBody.innerHTML = `<div class="studio-assistant__question studio-assistant__question--conversation studio-assistant__question--thinking">${assistantThread(false)}<div class="studio-assistant__message studio-assistant__message--assistant studio-assistant__message--thinking">${assistantAvatar}<div><p>${thinkingCopy}</p><span class="studio-assistant__thinking-line"><i></i><i></i><i></i><i></i><i></i><small>${thinkingLabel}</small></span></div></div></div>`;
  };

  const safeAssistantHref = (value, fallback = '#') => {
    const href = String(value || '');
    return href.startsWith('/') && !href.startsWith('//') ? href : fallback;
  };
  const isFinishedSetProduct = product => product?.set_type === 'finished'
    || product?.recipe?.set_type === 'finished'
    || String(product?.handle || '').endsWith('-finished-set')
    || (Array.isArray(product?.tags) && product.tags.includes('finished-set'));
  const renderAssistantLiveProducts = entry => {
    const products = (entry?.products || []).slice(0, 3);
    if (!products.length) return '';
    const cards = products.map(product => {
      const productHref = safeAssistantHref(product.url, `/products/${encodeURIComponent(product.handle || '')}`);
      const setHref = `/collections/all?view=design-studio&guided=0&set=${encodeURIComponent(product.studio_set_id || String(product.handle || '').replace(/-editable-set$/, ''))}&source=studio_assistant_set`;
      const price = Number(product.price || 0);
      const comparePrice = Number(product.compare_at_price || 0);
      const discount = comparePrice > price ? Math.round(((comparePrice - price) * 100) / comparePrice) : 0;
      const priceMarkup = product.kind === 'set' && price <= 0 ? '' : `<div class="studio-assistant-product__price"><strong>${escapeHTML(money(price))}</strong>${discount ? `<s>${escapeHTML(money(comparePrice))}</s><span>${discount}% OFF</span>` : ''}</div>`;
      const actions = product.kind === 'set' && !isFinishedSetProduct(product)
        ? `<a href="${escapeHTML(productHref)}">View set</a><a href="${escapeHTML(setHref)}">Edit in DIY</a>`
        : `<a href="${escapeHTML(productHref)}">View product</a>`;
      return `<article class="studio-assistant-product"><a class="studio-assistant-product__image" href="${escapeHTML(productHref)}" tabindex="-1">${product.image ? `<img src="${escapeHTML(product.image)}" alt="" loading="lazy">` : ''}</a><div class="studio-assistant-product__body"><h3>${escapeHTML(product.title)}</h3>${priceMarkup}<div class="studio-assistant-product__actions">${actions}</div></div></article>`;
    }).join('');
    const canImport = products.some(product => product?.kind !== 'set' && !isFinishedSetProduct(product) && byHandle.has(String(product?.handle || '')));
    return `<section class="studio-assistant__live-products"><header><strong>${escapeHTML(entry.productsTitle || 'Pieces to consider')}</strong>${entry.productsCopy ? `<span>${escapeHTML(entry.productsCopy)}</span>` : ''}</header><div class="studio-assistant__product-track">${cards}</div>${canImport ? `<button type="button" class="studio-assistant__products-import" data-assistant-live-products="${escapeHTML(entry.id)}">Start with these in DIY</button>` : ''}</section>`;
  };
  const renderAssistantLiveActions = entry => {
    const actions = Array.isArray(entry?.actions) ? entry.actions.slice(0, 2) : [];
    if (!actions.length) return '';
    return `<div class="studio-assistant__live-actions">${actions.map((action,index) => action.href
      ? `<a class="${action.quiet ? 'is-quiet' : ''}" href="${escapeHTML(safeAssistantHref(action.href))}">${escapeHTML(action.label)}</a>`
      : `<button type="button" class="${action.quiet ? 'is-quiet' : ''}" data-assistant-live-action="${escapeHTML(entry.id)}:${index}">${escapeHTML(action.label)}</button>`).join('')}</div>`;
  };

  const renderAssistantConsultation = entry => {
    assistantProgress.style.setProperty('--assistant-progress', '26%');
    const chinese = entry?.chinese;
    const actionLabel = entry?.cta || (chinese ? '根据这条建议生成搭配' : 'Create from this advice');
    assistantBody.innerHTML = `<div class="studio-assistant__question studio-assistant__question--conversation studio-assistant__question--consultation">
      ${assistantThread(false)}
      ${renderAssistantLiveProducts(entry)}
      ${renderAssistantLiveActions(entry)}
      <div class="studio-assistant__consult-actions">
        <button type="button" data-assistant-consult-design><strong>${escapeHTML(actionLabel)}</strong><span>${chinese ? '我会继续询问真正影响方案的信息' : 'I’ll ask only for details that change the result'}</span></button>
        <button type="button" data-assistant-consult-ask>${chinese ? '继续问问题' : 'Ask another question'}</button>
      </div>
    </div>`;
  };

  const renderAssistantClarification = () => {
    assistantProgress.style.setProperty('--assistant-progress', '64%');
    assistantBody.innerHTML = `<div class="studio-assistant__paused">${assistantAvatar}<div><p>I need a little more direction.</p><h2>Tell me what you want to change.</h2><span>Try a placement, a mood, or a size, such as “more sculptural” or “smaller for a shelf”.</span><button type="button" data-assistant-resume>Use my current answers</button></div></div>`;
  };

  const beginAssistantAnalysis = () => {
    assistantBusy = true;
    syncAssistantComposer();
    renderAssistantAnalysis();
    window.clearTimeout(assistantTimer);
    assistantTimer = window.setTimeout(() => {
      assistantPlans = createAssistantPlans();
      assistantBusy = false;
      syncAssistantComposer();
      const requestedPlan = Number(pageParams.get('plan'));
      if (assistant.classList.contains('is-recommendation-workspace') && pageParams.has('plan') && Number.isInteger(requestedPlan) && assistantPlans[requestedPlan]) {
        importAssistantPlan(assistantPlans[requestedPlan]);
      } else {
        renderAssistantResults();
      }
    }, 1450);
  };


  const handleAssistantLanguageFallback = value => {
    const parsed = parseAssistantLanguage(value);
    if (!parsed.text) return;
    if (['stop','cancel','close','end chat','停止','结束'].some(command => parsed.normalized === command)) {
      window.clearTimeout(assistantTimer); assistantRequestController?.abort(); assistantRequestController = null; assistantBusy = false; syncAssistantComposer(); setAssistantOpen(false); return;
    }
    if (['restart','start over','重新开始','重来'].some(command => parsed.normalized.includes(command))) {
      window.clearTimeout(assistantTimer); assistantRequestController?.abort(); assistantRequestController = null; assistantBusy = false; assistantStep = 0; assistantAnswers = {}; assistantPlans = []; assistantFreeText = null; assistantConversation = []; syncAssistantComposer(); renderAssistantWelcome(); return;
    }
    assistantPlans = [];
    const explicitRecommendation = wantsAssistantArrangement(parsed.normalized);
    const knowledgeResponse = explicitRecommendation ? null : assistantKnowledgeResponse(parsed);
    const inferredRecommendation = !knowledgeResponse && parsed.recognizedKeys.length > 0 && !looksLikeAssistantQuestion(parsed.normalized);
    const recommendationMode = explicitRecommendation || inferredRecommendation;
    if (recommendationMode) Object.assign(assistantAnswers, parsed.details);
    const response = recommendationMode ? {
      reply: parsed.chinese
        ? (parsed.understood.length ? `我记住了这些方向：${parsed.understood.join('、')}。接下来只补问尚未明确的信息。` : '可以。我会先确认真正影响搭配结果的信息，再生成多个可编辑方案。')
        : (parsed.understood.length ? `I understood ${parsed.understood.join(', ')}. I’ll only ask for what is still missing.` : 'Of course. I’ll confirm only the details that change the result, then prepare complete options you can edit.')
    } : knowledgeResponse || {
      reply: parsed.chinese
        ? '我可以直接回答花材搭配、花瓶比例、空间布置、养护和商品相关问题，也可以在你明确需要时生成可编辑的整套方案。你可以继续告诉我具体花材、花瓶或想了解的问题。'
        : 'I can directly answer questions about flower pairings, vase proportion, styling, care and products. When you want one, I can also shape a complete editable arrangement. Tell me the flower, vase or question you have in mind.',
      cta: parsed.chinese ? '帮我生成一套方案' : 'Build an arrangement'
    };
    assistantFreeText = {
      text: parsed.text,
      reply: response.reply,
      recognizedKeys: recommendationMode ? parsed.recognizedKeys : [],
      details: parsed.details,
      chinese: parsed.chinese,
      cta: response.cta,
      pending: true
    };
    assistantConversation.push(assistantFreeText);
    assistantBusy = true;
    syncAssistantComposer();
    renderAssistantNaturalThinking(parsed, recommendationMode ? 'recommendation' : 'consultation');
    window.clearTimeout(assistantTimer);
    assistantTimer = window.setTimeout(() => {
      assistantBusy = false;
      assistantFreeText.pending = false;
      syncAssistantComposer();
      if (!recommendationMode) { renderAssistantConsultation(assistantFreeText); return; }
      const next = firstUnansweredStep();
      if (parsed.understood.length && next < 0) { beginAssistantAnalysis(); return; }
      if (next >= 0) { assistantStep = next; renderAssistantQuestion(); return; }
      renderAssistantClarification();
    }, 760);
  };

  const assistantConversationPayload = () => assistantConversation.flatMap(entry => [
    {role:'user',text:String(entry.text || '')},
    ...(entry.pending || !entry.reply ? [] : [{role:'assistant',text:String(entry.reply || '')}])
  ]).filter(item => item.text).slice(-12);

  const handleAssistantLanguage = async value => {
    const parsed = parseAssistantLanguage(value);
    if (!parsed.text) return;
    if (['stop','cancel','close','end chat','停止','结束'].some(command => parsed.normalized === command)
      || ['restart','start over','重新开始','重来'].some(command => parsed.normalized.includes(command))) {
      handleAssistantLanguageFallback(parsed.text);
      return;
    }
    if (!assistantApiEndpoint) {
      handleAssistantLanguageFallback(parsed.text);
      return;
    }
    assistantPlans = [];
    Object.assign(assistantAnswers, parsed.details);
    const entry = {
      id:`studio-conversation-${assistantConversationSequence++}`,
      text:parsed.text,
      reply:'',
      recognizedKeys:parsed.recognizedKeys,
      details:parsed.details,
      chinese:parsed.chinese,
      pending:true,
      products:[],
      actions:[]
    };
    assistantFreeText = entry;
    assistantConversation.push(entry);
    assistantBusy = true;
    syncAssistantComposer();
    renderAssistantNaturalThinking(parsed, wantsAssistantArrangement(parsed.normalized) ? 'recommendation' : 'consultation');
    const controller = new AbortController();
    assistantRequestController = controller;
    try {
      const response = await fetch(assistantApiEndpoint, {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        signal:controller.signal,
        body:JSON.stringify({
          message:parsed.text,
          conversation:assistantConversationPayload(),
          context:{page_type:'design_studio',template:'collection.design-studio',locale:document.documentElement.lang || 'en'},
          recommendation:{...assistantAnswers,focus:pageParams.get('focus') || null,vase:pageParams.get('vase') || null}
        })
      });
      if (!response.ok) throw new Error('Studio Assistant request failed');
      const result = await response.json();
      entry.reply = String(result.message || (parsed.chinese ? '我已经根据当前商品整理了结果。' : 'I found a direction using the current catalogue.'));
      entry.pending = false;
      entry.products = Array.isArray(result.products) ? result.products.slice(0, 3) : [];
      entry.productsTitle = String(result.products_title || 'Pieces to consider');
      entry.productsCopy = String(result.products_copy || 'Selected from currently available pieces.');
      entry.actions = Array.isArray(result.actions) ? result.actions.slice(0, 2) : [];
      if (result.recommendation && typeof result.recommendation === 'object') {
        for (const key of ['space','mood','scale']) if (result.recommendation[key]) assistantAnswers[key] = result.recommendation[key];
      }
      const livePlans = (Array.isArray(result.plans) ? result.plans : []).slice(0, 3).map((plan,index) => normalizeAssistantPlan({...plan,layoutIndex:index})).filter(Boolean);
      assistantPlans = livePlans;
      assistantBusy = false;
      assistantRequestController = null;
      syncAssistantComposer();
      if (assistantPlans.length) renderAssistantResults();
      else renderAssistantConsultation(entry);
    } catch (error) {
      if (error.name === 'AbortError') return;
      assistantConversation = assistantConversation.filter(item => item !== entry);
      if (assistantFreeText === entry) assistantFreeText = null;
      assistantBusy = false;
      assistantRequestController = null;
      syncAssistantComposer();
      handleAssistantLanguageFallback(parsed.text);
    } finally {
      if (assistantRequestController === controller) {
        assistantRequestController = null;
        assistantBusy = false;
        syncAssistantComposer();
      }
    }
  };

  const choiceFor = question => question.choices.find(choice => choice.value === assistantAnswers[question.key]);
  const assistantThread = (includeCurrent = true) => {
    const answered = assistantQuestions.slice(0, assistantStep).filter(question => !assistantFreeText?.recognizedKeys?.includes(question.key)).map(question => {
      const choice = choiceFor(question);
      return `<div class="studio-assistant__exchange"><div class="studio-assistant__message studio-assistant__message--assistant">${assistantAvatar}<p>${question.title}</p></div><div class="studio-assistant__message studio-assistant__message--user"><p>${escapeHTML(choice?.label || '')}</p></div></div>`;
    }).join('');
    const current = assistantQuestions[assistantStep];
    const natural = assistantConversation.map(entry => `<div class="studio-assistant__message studio-assistant__message--user studio-assistant__message--natural"><p>${escapeHTML(entry.text)}</p></div>${entry.pending ? '' : `<div class="studio-assistant__message studio-assistant__message--assistant">${assistantAvatar}<p>${escapeHTML(entry.reply)}</p></div>`}`).join('');
    const intro = seededProductRecord
      ? `I’ll keep ${escapeHTML(seededProductRecord.title)} in every direction. Three short answers will help me choose the right proportion and supporting pieces.`
      : 'Ask me a flower question, or tell me what you want to create. I’ll only ask for room details when they improve a recommendation.';
    return `<div class="studio-assistant__thread"><div class="studio-assistant__message studio-assistant__message--assistant studio-assistant__message--intro">${assistantAvatar}<p>${intro}</p></div>${natural}${answered}${includeCurrent && current ? `<div class="studio-assistant__message studio-assistant__message--assistant studio-assistant__message--current">${assistantAvatar}<div><small>${current.eyebrow}</small><p>${current.title}</p><em>${current.copy}</em></div></div>` : ''}</div>`;
  };

  const renderAssistantWelcome = () => {
    assistant.classList.remove('is-recommendation-workspace');
    assistantProgress.style.setProperty('--assistant-progress', '12%');
    assistantBody.innerHTML = `<div class="studio-assistant__question studio-assistant__question--conversation studio-assistant__question--welcome">
      <div class="studio-assistant__thread"><div class="studio-assistant__message studio-assistant__message--assistant studio-assistant__message--intro">${assistantAvatar}<p>Ask me about flower pairings, vase proportion, styling or care. If you want to create, choose a path below or describe the result in the message box.</p></div></div>
      <div class="studio-assistant__response"><span>Or start creating</span><div class="studio-assistant__choices">
        <button class="studio-assistant__choice" type="button" data-assistant-browse-sets><strong>Choose a set</strong><span>Place a complete composition on the canvas, then change any piece.</span></button>
        <button class="studio-assistant__choice" type="button" data-assistant-guide-me><strong>Guide me</strong><span>Answer three short questions for tailored starting points.</span></button>
        <button class="studio-assistant__choice" type="button" data-assistant-start-free><strong>Build freely</strong><span>Begin with the vase and material library on the left.</span></button>
      </div></div>
    </div>`;
  };

  const openAssistantWelcome = () => {
    window.clearTimeout(assistantTimer);
    assistantRequestController?.abort();
    assistantRequestController = null;
    assistantBusy = false;
    assistantStep = 0;
    assistantAnswers = {};
    assistantPlans = [];
    assistantFreeText = null;
    assistantConversation = [];
    syncAssistantComposer();
    renderAssistantWelcome();
    closeOnboarding();
    setAssistantOpen(true);
  };
  const openSharedAssistant = (detail = {}) => {
    closeOnboarding();
    setAssistantOpen(false);
    document.dispatchEvent(new CustomEvent('floralsculpt:assistant-open', {detail}));
  };
  const scheduleSharedAssistant = (detail = {}, delay = 0) => {
    const schedule = () => window.setTimeout(() => {
      const assistantReady = document.querySelector('[data-global-assistant][data-global-assistant-ready="true"]');
      if (assistantReady) {
        openSharedAssistant(detail);
        return;
      }
      document.addEventListener('floralsculpt:assistant-ready', () => openSharedAssistant(detail), {once:true});
    }, delay);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, {once:true});
    else schedule();
  };
  const openSeededProductAssistant = () => {
    if (isOperator || !seededProductRecord) return;
    const recommendation = seededProductIsVase
      ? {vase:seededProductRecord.handle}
      : {focus:seededProductRecord.handle};
    scheduleSharedAssistant({
      intent:'recommend',
      recommendation,
      product:{
        handle:seededProductRecord.handle,
        title:seededProductRecord.title,
        type:seededProductRecord.product_type || '',
        category:seededProductRecord.category,
        available:Boolean(seededProductRecord.variants?.some(variant => variant.available)),
        editable_set:false,
        studio_set_id:'',
        url:seededProductRecord.url || `/products/${encodeURIComponent(seededProductRecord.handle)}`
      }
    }, 180);
  };
  root.querySelector('[data-studio-assistant-header-open]')?.addEventListener('click', () => {
    if (seededProductRecord) {
      openSeededProductAssistant();
      return;
    }
    openSharedAssistant();
  });

  const renderAssistantQuestion = () => {
    const question = assistantQuestions[assistantStep];
    assistantProgress.style.setProperty('--assistant-progress', `${((assistantStep + 1) / (assistantQuestions.length + 1)) * 100}%`);
    assistantBody.innerHTML = `<div class="studio-assistant__question studio-assistant__question--conversation">
      ${assistantThread()}
      <div class="studio-assistant__response"><span>Choose a response</span><div class="studio-assistant__choices">${question.choices.map(choice => `<button class="studio-assistant__choice" type="button" data-assistant-choice="${choice.value}"><strong>${choice.label}</strong><span>${choice.copy}</span></button>`).join('')}</div></div>
    </div>`;
  };

  const renderAssistantThinking = choice => {
    const question = assistantQuestions[assistantStep];
    assistantProgress.style.setProperty('--assistant-progress', `${((assistantStep + 1.55) / (assistantQuestions.length + 1)) * 100}%`);
    assistantBody.innerHTML = `<div class="studio-assistant__question studio-assistant__question--conversation studio-assistant__question--thinking">
      ${assistantThread(false)}
      <div class="studio-assistant__exchange"><div class="studio-assistant__message studio-assistant__message--assistant">${assistantAvatar}<p>${question.title}</p></div><div class="studio-assistant__message studio-assistant__message--user"><p>${escapeHTML(choice.label)}</p></div></div>
      <div class="studio-assistant__message studio-assistant__message--assistant studio-assistant__message--thinking">${assistantAvatar}<div><p>${assistantStep === 0 ? 'I’m adjusting the silhouette and viewing angle for that placement.' : assistantStep === 1 ? 'I’m translating that mood into colour, line and botanical texture.' : 'I’m balancing stem count, vessel scale and overall presence.'}</p><span class="studio-assistant__thinking-line"><i></i><i></i><i></i><i></i><i></i><small>Considering your answer</small></span></div></div>
    </div>`;
  };

  const renderAssistantAnalysis = () => {
    assistantProgress.style.setProperty('--assistant-progress', '88%');
    const answers = assistantQuestions.map(question => choiceFor(question)?.label).filter(Boolean);
    assistantBody.innerHTML = `<div class="studio-assistant__analysis"><span class="studio-assistant__analysis-mark" aria-hidden="true"><i></i><i></i><i></i><span class="studio-assistant__analysis-bars"><b></b><b></b><b></b><b></b><b></b><b></b><b></b></span></span><p>I have the direction.</p><h2>Composing three starting points.</h2><div class="studio-assistant__analysis-context">${answers.map(answer => `<span>${escapeHTML(answer)}</span>`).join('')}</div><div class="studio-assistant__analysis-steps"><span style="--analysis-delay:0">Matching vessel proportion</span><span style="--analysis-delay:1">Balancing stems and structure</span><span style="--analysis-delay:2">Checking live availability and price</span></div></div>`;
  };

  const availableCatalog = category => catalog.filter(record => record.category === category && record.variants?.some(variant => variant.available));
  const recordPrice = record => Number(record?.variants?.find(variant => variant.available)?.price_minor || record?.variants?.[0]?.price_minor || 0);
  const assistantTerms = () => ({
    space: {dining:['dining','table','low','bowl'],console:['console','entryway','tall','branch'],shelf:['shelf','bedside','bud','small']},
    mood: {airy:['white','ivory','cream','magnolia','glass','sage'],sculptural:['branch','greenery','emerald','stoneware','dark'],soft:['pink','blush','peony','rose','coral']}
  });
  const rankedRecords = (records, terms, offset = 0) => records.map((record,index) => {
    const haystack = `${record.search_text || ''} ${record.title || ''} ${record.handle || ''}`.toLowerCase();
    const score = terms.reduce((sum,term) => sum + (haystack.includes(term) ? 4 : 0), 0);
    return {record,score,index};
  }).sort((a,b) => b.score - a.score || a.index - b.index).map(entry => entry.record).slice(offset).concat(records).filter((record,index,array) => array.indexOf(record) === index);

  const createAssistantPlans = () => {
    const termsByGroup = assistantTerms();
    const focusTerms = String(pageParams.get('focus') || '').toLowerCase().split(/[\s,]+/).filter(Boolean);
    const terms = [...focusTerms, ...(termsByGroup.space[assistantAnswers.space] || []), ...(termsByGroup.mood[assistantAnswers.mood] || [])];
    let vases = rankedRecords(availableCatalog('vase').filter(record => record.canvas_image), terms);
    const preferredVase = pageParams.get('vase');
    if (preferredVase) vases = [...vases].sort((a,b) => Number(b.handle === preferredVase) - Number(a.handle === preferredVase));
    if (seededProductIsVase && seededProductRecord?.status === 'available') {
      vases = [seededProductRecord, ...vases.filter(record => record !== seededProductRecord)];
    }
    const flowers = rankedRecords(availableCatalog('flower').filter(record => record.canvas_image), terms);
    const greenery = rankedRecords(availableCatalog('greenery').filter(record => record.canvas_image), terms);
    const lines = rankedRecords(availableCatalog('line').filter(record => record.canvas_image), terms);
    const quantities = {compact:[2,1,1],balanced:[3,2,1],statement:[4,3,2]}[assistantAnswers.scale] || [3,2,1];
    const placementReason = {
      dining:'A lower, all-round silhouette keeps conversation sightlines open.',
      console:'A front-facing silhouette adds height without using too much surface depth.',
      shelf:'A compact footprint keeps the arrangement considered at close range.'
    }[assistantAnswers.space] || 'The proportion is matched to the placement.';
    const moodReason = {
      airy:'Ivory florals and lighter greenery leave visual breathing room.',
      sculptural:'Branches and stronger lines create a more asymmetric gesture.',
      soft:'Muted bloom colour warms the room without becoming overly sweet.'
    }[assistantAnswers.mood] || 'Colour and botanical texture follow your chosen mood.';
    const scaleReason = {
      compact:'A restrained stem count keeps the edit quiet.',
      balanced:'The stem count gives the room presence without taking over.',
      statement:'Additional structure and stems create a fuller focal point.'
    }[assistantAnswers.scale] || 'The stem count is balanced for the room.';
    const names = ['Quiet Magnolia','Coral Balance','Sculptural Burgundy'];
    const summaries = [`${placementReason} ${moodReason}`,`${scaleReason} A softer alternative keeps it easy to edit.`,`${moodReason} This version pushes the silhouette a little further.`];
    const findPreferred = (records,handles,index) => handles.map(handle => records.find(record => record.handle === handle)).find(Boolean) || records[index % Math.max(1,records.length)];
    const recipes = [
      {vases:['emerald-glazed-low-bowl'],botanicals:[{records:flowers,handles:['ivory-magnolia-stem'],quantity:quantities[0]},{records:greenery,handles:['olive-veil-greenery'],quantity:quantities[1]}]},
      {vases:['onyx-ceramic-bud-vase','emerald-glazed-low-bowl'],botanicals:[{records:flowers,handles:['coral-garden-peony-stem'],quantity:quantities[0]},{records:greenery,handles:['willow-eucalyptus-branch','fern-mist-greenery'],quantity:quantities[1]}]},
      {vases:['verdant-recycled-glass-vase','emerald-glazed-low-bowl'],botanicals:[{records:flowers,handles:['burgundy-garden-rose-stem'],quantity:quantities[0]},{records:lines,handles:['burnished-beech-branch'],quantity:quantities[1]},{records:greenery,handles:['seeded-sage-spray','olive-veil-greenery'],quantity:quantities[2]}]}
    ];
    return recipes.map((recipe,planIndex) => {
      const vase = seededProductIsVase && seededProductRecord?.status === 'available' ? seededProductRecord : findPreferred(vases,recipe.vases,planIndex);
      const chosen = recipe.botanicals.map((spec,index) => ({record:findPreferred(spec.records,spec.handles,planIndex + index),quantity:spec.quantity})).filter(line => line.record);
      let unique = chosen.filter((line,index,array) => array.findIndex(item => item.record === line.record) === index);
      if (seededProductRecord && !seededProductIsVase && seededProductRecord.status === 'available') {
        const currentSeedLine = selection.items.find(line => String(line.product_id) === String(seededProductRecord.product_id));
        const currentSeedQuantity = Math.max(1, Number(currentSeedLine?.quantity || 1));
        unique = [
          {record:seededProductRecord,quantity:currentSeedQuantity},
          ...unique.filter(line => line.record !== seededProductRecord && line.record.category !== seededProductRecord.category)
        ];
      }
      const seededPlanName = String(vase?.title || `Direction ${planIndex + 1}`).replace(/\s+-\s+[\d.]+.*$/, '').split(/\s+/).slice(0,3).join(' ');
      const planName = seededProductRecord ? `${seededPlanName} Edit` : names[planIndex];
      const planSummary = seededProductRecord
        ? `This direction keeps your starting ${seedProductLabel} and changes the proportion with ${vase?.title || 'an available vase'}, supported by live florals and greenery.`
        : summaries[planIndex];
      return {id:`studio-test-${planIndex}`,layoutIndex:planIndex,name:planName,summary:planSummary,lines:[
        ...(vase ? [{record:vase,quantity:1,isVase:true}] : []),
        ...unique.map(line => ({...line,isVase:false}))
      ]};
    }).filter(plan => plan.lines.length > 1);
  };

  const studioPlacementSets = [
    {
      flower:[{x:50,y:45,scale:.78,rotation:0,z:14},{x:43,y:49,scale:.7,rotation:-14,z:13},{x:57,y:49,scale:.7,rotation:14,z:13},{x:48,y:52,scale:.64,rotation:-4,z:15}],
      greenery:[{x:39,y:49,scale:.8,rotation:-20,z:5},{x:61,y:49,scale:.8,rotation:20,z:5},{x:52,y:48,scale:.72,rotation:7,z:6}],
      line:[{x:44,y:43,scale:.86,rotation:-12,z:3},{x:57,y:44,scale:.82,rotation:13,z:3}]
    },
    {
      flower:[{x:47,y:47,scale:.76,rotation:-7,z:14},{x:55,y:48,scale:.72,rotation:10,z:13},{x:41,y:52,scale:.64,rotation:-18,z:12},{x:59,y:52,scale:.62,rotation:17,z:12}],
      greenery:[{x:38,y:47,scale:.82,rotation:-24,z:4},{x:63,y:50,scale:.78,rotation:22,z:4},{x:51,y:51,scale:.7,rotation:4,z:6}],
      line:[{x:55,y:42,scale:.88,rotation:10,z:3},{x:43,y:45,scale:.78,rotation:-16,z:3}]
    },
    {
      flower:[{x:46,y:48,scale:.74,rotation:-10,z:14},{x:55,y:50,scale:.68,rotation:12,z:13},{x:50,y:44,scale:.72,rotation:2,z:15},{x:40,y:52,scale:.6,rotation:-20,z:12}],
      greenery:[{x:36,y:50,scale:.82,rotation:-25,z:5},{x:62,y:51,scale:.78,rotation:22,z:5},{x:52,y:52,scale:.66,rotation:6,z:6}],
      line:[{x:43,y:40,scale:.92,rotation:-14,z:3},{x:58,y:42,scale:.88,rotation:15,z:3},{x:50,y:39,scale:.82,rotation:0,z:2}]
    }
  ];
  const placementsForLine = (line,planIndex,offset) => {
    const pool = studioPlacementSets[planIndex % studioPlacementSets.length][line.record.category] || studioPlacementSets[0].flower;
    return Array.from({length:line.quantity},(_,index) => ({...pool[(offset + index) % pool.length],length:100}));
  };

  const renderAssistantResults = () => {
    assistantProgress.style.setProperty('--assistant-progress', '100%');
    assistantPlans = assistantPlans.length ? assistantPlans : createAssistantPlans();
    const cards = assistantPlans.map((plan,planIndex) => {
      const total = plan.lines.reduce((sum,line) => sum + recordPrice(line.record) * line.quantity,0);
      const compositeReady = plan.lines.length > 1 && plan.lines.every(line => line.record.canvas_image);
      const previewImages = plan.lines.map((line,index) => {
        const source = line.record.canvas_image || line.record.image;
        return source ? `<img src="${escapeHTML(source)}" alt="" data-category="${escapeHTML(line.record.category)}" data-index="${index}">` : '';
      }).join('');
      const itemRows = plan.lines.map((line,lineIndex) => `<div class="studio-plan__item${line.isVase ? ' studio-plan__item--vase' : ''}">
        ${line.record.image ? `<img src="${escapeHTML(line.record.image)}" alt="">` : '<span></span>'}
        <span>${escapeHTML(line.record.title)}</span><small>${line.isVase ? 'Vase' : `× ${line.quantity}`}</small>
        ${line.isVase ? '' : `<button type="button" data-assistant-remove="${planIndex}:${lineIndex}" aria-label="Remove ${escapeHTML(line.record.title)}">×</button>`}
      </div>`).join('');
      return `<article class="studio-plan"><div class="studio-plan__preview"><span>Your starting composition</span><div class="studio-plan__visual${compositeReady ? '' : ' studio-plan__visual--collage'}">${previewImages}</div></div>
        <div class="studio-plan__body"><div class="studio-plan__heading"><h3>${escapeHTML(plan.name)}</h3><strong>${money(total)}</strong></div><small class="studio-plan__reason-label">Why it fits</small><p class="studio-plan__summary">${escapeHTML(plan.summary)}</p><div class="studio-plan__items">${itemRows}</div><button class="studio-plan__use" type="button" data-assistant-import="${planIndex}">Use this starting point</button></div></article>`;
    }).join('');
    const resultHeading = seededProductRecord
      ? `${assistantPlans.length === 1 ? 'One way' : `${assistantPlans.length} ways`} to build around your ${seedProductLabel}.`
      : `I found ${assistantPlans.length === 1 ? 'one direction' : `${assistantPlans.length} directions`} for your room.`;
    assistantBody.innerHTML = `<div class="studio-assistant__results"><header class="studio-assistant__results-heading"><div><span>Based on what you told me</span><h2>${resultHeading}</h2><p>Each recommendation uses live products${seededProductRecord ? ' and keeps your starting piece' : ''}. Remove any stem you do not want, then continue refining it on the canvas.</p></div><button class="studio-assistant__change" type="button" data-assistant-restart>Change answers</button></header><div class="studio-plan-grid">${cards}</div></div>`;
  };

  const importAssistantPlan = plan => {
    if (!plan) return;
    const vase = plan.lines.find(line => line.isVase);
    const botanicalLines = plan.lines.filter(line => !line.isVase && line.record?.material_id);
    let placementIndex = 0;
    const payload = {
      type:'floree:studio-import',command_id:`assistant-${Date.now()}`,
      allow_unavailable:true,
      vase_material_id:vase?.record?.material_id || null,
      items:botanicalLines.map(line => {
        const placements = placementsForLine(line,plan.layoutIndex || 0,placementIndex);
        placementIndex += line.quantity;
        return {material_id:line.record.material_id,quantity:line.quantity,placements};
      })
    };
    if (!payload.vase_material_id && !payload.items.length) return;
    pendingStudioCategory = payload.vase_material_id ? (payload.items.length ? null : 'flower') : 'vase';
    if (studioReady) send(payload); else pendingAssistantPlan = payload;
    if (studioReady && pendingStudioCategory) window.setTimeout(() => focusStudioCategory(pendingStudioCategory), 160);
    setAssistantOpen(false);
  };
  const sidebarLinesNode = root.querySelector('[data-native-studio-lines]');
  const sidebarLineNodes = new Map();
  const sidebarLineKey = line => `${line.isVase ? 'vase' : 'item'}:${line.material_id || line.product_id || line.product_handle || 'unknown'}`;
  const createSidebarLine = line => {
    const article = document.createElement('article');
    article.className = 'design-sidebar-line';
    article.innerHTML = `<div class="design-sidebar-line__image"></div><div class="design-sidebar-line__copy"><p class="micro-label"></p><h3></h3><span></span></div><div class="design-sidebar-line__actions">${line.isVase?'<div class="quantity-control quantity-control--compact quantity-control--fixed"><button type="button" disabled aria-hidden="true">−</button><input value="1" readonly><button type="button" disabled aria-hidden="true">+</button></div>':'<div class="quantity-control quantity-control--compact"><button type="button" data-studio-delta="-1">−</button><input readonly><button type="button" data-studio-delta="1">+</button></div>'}<strong></strong></div>`;
    return article;
  };
  const updateSidebarLine = (article,line) => {
    const unavailable = !line.variant?.available;
    const lineImage = line.product?.canvas_image || line.variant?.image || line.product?.image;
    const operatorType = line.isVase ? '花器' : line.product?.category === 'line' ? '枝材' : line.product?.category === 'greenery' ? '叶材' : '花材';
    const lineType = isOperator ? operatorType : line.isVase ? 'Vase' : line.product?.product_type || 'Product';
    const unavailableText = unavailable ? (isOperator ? ' · 缺货' : ' · Unavailable') : '';
    const fixedQuantityLabel = isOperator ? '每个套装固定一个花器' : 'One vase per arrangement';
    const quantityLabel = isOperator ? '数量' : 'Quantity';
    const lineTitle = line.product?.title || line.product_title || (isOperator ? '未知商品' : 'Unknown product');
    const priceCopy = isOperator && !line.product
      ? '未在当前目录 · 请替换'
      : `${money(line.variant?.price_minor)}${line.variant?.title&&line.variant.title!=='Default Title'?` · ${line.variant.title}`:''}${unavailableText}`;
    article.classList.toggle('design-sidebar-line--unavailable', unavailable);
    const imageNode = article.querySelector('.design-sidebar-line__image');
    let image = imageNode.querySelector('img');
    if (lineImage) {
      imageNode.querySelector('span')?.remove();
      if (!image) { image = document.createElement('img'); image.alt = ''; image.decoding = 'async'; imageNode.appendChild(image); }
      if (image.getAttribute('src') !== lineImage) image.src = lineImage;
    } else {
      image?.remove();
      if (!imageNode.querySelector('span')) { const fallback = document.createElement('span'); fallback.textContent = '?'; imageNode.appendChild(fallback); }
    }
    article.querySelector('.micro-label').textContent = lineType;
    const title = article.querySelector('h3'); title.textContent = lineTitle; title.title = lineTitle;
    article.querySelector('.design-sidebar-line__copy > span').textContent = priceCopy;
    const quantityControl = article.querySelector('.quantity-control');
    quantityControl.setAttribute('aria-label', line.isVase ? fixedQuantityLabel : quantityLabel);
    const input = quantityControl.querySelector('input'); input.value = String(line.isVase ? 1 : line.quantity); input.setAttribute('aria-label', quantityLabel);
    if (!line.isVase) {
      const [decrease,increase] = quantityControl.querySelectorAll('button');
      decrease.dataset.material = line.material_id; increase.dataset.material = line.material_id;
      decrease.setAttribute('aria-label', `${isOperator ? (line.quantity===1?'移除':'减少') : (line.quantity===1?'Remove':'Decrease')} ${lineTitle}`);
      increase.setAttribute('aria-label', `${isOperator ? '增加' : 'Increase'} ${lineTitle}`);
    }
    article.querySelector('.design-sidebar-line__actions strong').textContent = isOperator&&!line.product ? '—' : money(line.lineTotal);
  };
  const render = () => {
    const list = lines(), units = list.reduce((sum,line) => sum + line.quantity,0), total = list.reduce((sum,line) => sum + line.lineTotal,0);
    const displayVaseNote = root.querySelector('[data-native-studio-display-vase]');
    if (displayVaseNote) displayVaseNote.hidden = selection.vase?.display_only !== true;
    if (!list.length) {
      sidebarLineNodes.clear();
      sidebarLinesNode.innerHTML = `<div class="design-sidebar-empty"><span>01</span><p>${isOperator ? '请从左侧添加花材。' : 'Add botanicals from the material library.'}</p></div>`;
    } else {
      const wanted = new Set(list.map(sidebarLineKey));
      for (const [key,node] of sidebarLineNodes) if (!wanted.has(key)) { node.remove(); sidebarLineNodes.delete(key); }
      if (sidebarLinesNode.querySelector('.design-sidebar-empty')) sidebarLinesNode.replaceChildren();
      list.forEach(line => {
        const key = sidebarLineKey(line);
        let article = sidebarLineNodes.get(key);
        if (!article) { article = createSidebarLine(line); sidebarLineNodes.set(key, article); }
        updateSidebarLine(article,line);
        sidebarLinesNode.appendChild(article);
      });
    }
    root.querySelector('[data-native-studio-units]').textContent = isOperator ? `${units} 件` : `${units} piece${units===1?'':'s'}`;
    root.querySelector('[data-native-studio-total]').textContent = money(total);
    const cart = root.querySelector('[data-native-studio-cart]');
    if (!cart) return;
    const purchasable = list.length >= 2 && list.every(line => line.variant?.available && line.variant?.id);
    cart.disabled = !purchasable;
    cart.textContent = purchasable ? `Add to cart · ${money(total)}` : list.length < 2 ? 'Add to cart' : 'Review unavailable pieces';
  };
  const flushStudioReadyState = () => {
    sendCatalogIfReady();
    if (pendingStudioCategory) {
      const pendingCategory = pendingStudioCategory;
      pendingStudioCategory = null;
      window.setTimeout(() => send({type:'floree:studio-focus-category',category:pendingCategory}), 120);
    }
    if (pendingAssistantPlan) {
      const pending = pendingAssistantPlan;
      pendingAssistantPlan = null;
      window.setTimeout(() => send(pending), 120);
    }
  };
  window.addEventListener('message', event => {
    if (event.source !== frame.contentWindow) return;
    const message = event.data || {};
    if (message.version !== 2 || message.session_id !== sessionId) return;
    if (message.type === 'floree:studio-modal-state') {
      root.classList.toggle('is-studio-modal-open', Boolean(message.open));
      return;
    }
    if (message.type === 'floree:studio-ready') {
      studioReady = true;
      flushStudioReadyState();
    }
    if (message.type === 'floree:studio-rendered') {
      markStudioRendered();
      return;
    }
    if (!['floree:studio-ready','floree:studio-selection'].includes(message.type)) return;
    if (message.type === 'floree:studio-selection' && Number(message.seq) <= seq) return;
    if (message.type === 'floree:studio-selection') seq = Number(message.seq);
    selection = {vase:message.vase || null,items:Array.isArray(message.items)?message.items:[]};
    root.floralsculptStudioSelection = message;
    root.dispatchEvent(new CustomEvent('floralsculpt:studio-selection', {detail:message}));
    render();
    if (message.type === 'floree:studio-selection') send({type:'floree:studio-selection-ack',seq:message.seq});
  });
  messageHandlerReady = true;
  window.removeEventListener('message', captureEarlyStudioReady);
  if (earlyRendered) markStudioRendered();
  if (studioReady) flushStudioReadyState();
  root.addEventListener('click', async event => {
    const assistantChoice = event.target.closest('[data-assistant-choice]');
    if (assistantChoice && !assistantBusy) {
      const question = assistantQuestions[assistantStep];
      const choice = question.choices.find(item => item.value === assistantChoice.dataset.assistantChoice);
      if (!choice) return;
      assistantBusy = true;
      assistantAnswers[question.key] = choice.value;
      syncAssistantComposer();
      renderAssistantThinking(choice);
      window.clearTimeout(assistantTimer);
      assistantTimer = window.setTimeout(() => {
        const next = firstUnansweredStep();
        if (next >= 0) {
          assistantStep = next;
          assistantBusy = false;
          syncAssistantComposer();
          renderAssistantQuestion();
        } else {
          beginAssistantAnalysis();
        }
      }, 760);
      return;
    }
    const assistantLiveProducts = event.target.closest('[data-assistant-live-products]');
    if (assistantLiveProducts) {
      const entry = assistantConversation.find(item => item.id === assistantLiveProducts.dataset.assistantLiveProducts);
      const plan = normalizeAssistantPlan({
        name:entry?.productsTitle || 'AI recommended pieces',
        summary:entry?.productsCopy || '',
        lines:(entry?.products || []).filter(product => product?.kind !== 'set' && !isFinishedSetProduct(product)).map(product => ({handle:product.handle,quantity:1}))
      });
      importAssistantPlan(plan);
      return;
    }
    const assistantLiveAction = event.target.closest('[data-assistant-live-action]');
    if (assistantLiveAction && !assistantBusy) {
      const token = assistantLiveAction.dataset.assistantLiveAction;
      const separator = token.lastIndexOf(':');
      const entry = assistantConversation.find(item => item.id === token.slice(0, separator));
      const action = entry?.actions?.[Number(token.slice(separator + 1))];
      if (action?.value) handleAssistantLanguage(String(action.value).replace(/^prompt:/, ''));
      return;
    }
    if (event.target.closest('[data-assistant-consult-design]')) {
      Object.assign(assistantAnswers, assistantFreeText?.details || {});
      if (assistantFreeText) assistantFreeText.recognizedKeys = Object.keys(assistantFreeText.details || {});
      const next = firstUnansweredStep();
      if (next < 0) beginAssistantAnalysis();
      else { assistantStep = next; renderAssistantQuestion(); }
      return;
    }
    if (event.target.closest('[data-assistant-consult-ask]')) {
      assistantInput.focus();
      return;
    }
    if (event.target.closest('[data-assistant-skip]')) { setAssistantOpen(false); return; }
    if (event.target.closest('[data-assistant-end]')) {
      window.clearTimeout(assistantTimer);
      assistantRequestController?.abort();
      assistantRequestController = null;
      assistantBusy = false;
      assistantStep = 0;
      assistantAnswers = {};
      assistantPlans = [];
      assistantFreeText = null;
      assistantConversation = [];
      syncAssistantComposer();
      renderAssistantWelcome();
      return;
    }
    if (event.target.closest('[data-assistant-stop-response]')) {
      window.clearTimeout(assistantTimer); assistantRequestController?.abort(); assistantRequestController = null; assistantBusy = false; syncAssistantComposer(); renderAssistantPaused(); return;
    }
    if (event.target.closest('[data-assistant-resume]')) {
      if (firstUnansweredStep() < 0) beginAssistantAnalysis();
      else { assistantStep = firstUnansweredStep(); renderAssistantQuestion(); }
      return;
    }
    if (event.target.closest('[data-assistant-open]')) { openAssistantWelcome(); return; }
    if (event.target.closest('[data-assistant-browse-sets]')) {
      setAssistantOpen(false);
      focusStudioCategory('set');
      return;
    }
    if (event.target.closest('[data-assistant-guide-me]')) {
      assistantStep = 0;
      assistantAnswers = {};
      assistantPlans = [];
      assistantFreeText = null;
      assistantConversation = [];
      renderAssistantQuestion();
      return;
    }
    if (event.target.closest('[data-assistant-start-free]')) {
      setAssistantOpen(false);
      focusStudioCategory('vase');
      return;
    }
    if (event.target.closest('[data-assistant-restart]')) {
      window.clearTimeout(assistantTimer); assistantRequestController?.abort(); assistantRequestController = null; assistantBusy = false;
      assistantStep = 0; assistantAnswers = {}; assistantPlans = []; assistantFreeText = null; assistantConversation = []; syncAssistantComposer(); renderAssistantQuestion(); return;
    }
    const assistantRemove = event.target.closest('[data-assistant-remove]');
    if (assistantRemove) {
      const [planIndex,lineIndex] = assistantRemove.dataset.assistantRemove.split(':').map(Number);
      if (!assistantPlans[planIndex]?.lines[lineIndex]?.isVase) assistantPlans[planIndex].lines.splice(lineIndex,1);
      renderAssistantResults(); return;
    }
    const assistantImport = event.target.closest('[data-assistant-import]');
    if (assistantImport) { importAssistantPlan(assistantPlans[Number(assistantImport.dataset.assistantImport)]); return; }
    const quantity = event.target.closest('[data-studio-delta]');
    if (quantity) {
      send({type:'floree:studio-adjust',command_id:`native-${Date.now()}`,material_id:quantity.dataset.material,delta:Number(quantity.dataset.studioDelta)});
      return;
    }
    const cart = event.target.closest('[data-native-studio-cart]');
    if (!cart || cart.disabled) return;
    const current = lines();
    cart.disabled = true; cart.textContent = 'Adding…';
    try {
      const response = await fetch(window.theme?.routes?.cartAdd ? `${window.theme.routes.cartAdd}.js` : '/cart/add.js', {
        method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:current.map(line => ({id:line.variant.id,quantity:line.quantity,properties:{_floree_source:'design_studio'}}))})
      });
      if (!response.ok) throw new Error('Cart request failed');
      render();
      document.querySelector('[data-open-cart]')?.click();
    } catch (_) {
      cart.disabled = false; cart.textContent = 'Please try again';
    }
  });
  root.addEventListener('submit', event => {
    if (!event.target.matches('[data-assistant-form]')) return;
    event.preventDefault();
    if (assistantBusy) return;
    const value = assistantInput.value;
    assistantInput.value = '';
    handleAssistantLanguage(value);
  });
  root.addEventListener('click', event => {
    if (event.target.closest('[data-studio-onboarding-close]')) { closeOnboarding(); return; }
    if (event.target.closest('[data-studio-start-vase]')) {
      closeOnboarding();
      focusStudioCategory('vase');
      return;
    }
    if (event.target.closest('[data-studio-start-set]')) {
      closeOnboarding();
      focusStudioCategory('set');
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && assistant.classList.contains('is-open')) setAssistantOpen(false);
  });
  const guidedValues = {
    space: pageParams.get('space'),
    mood: pageParams.get('mood'),
    scale: pageParams.get('scale')
  };
  const validGuidedValues = ['dining','console','shelf'].includes(guidedValues.space)
    && ['airy','sculptural','soft'].includes(guidedValues.mood)
    && ['compact','balanced','statement'].includes(guidedValues.scale);
  const guidedRequested = pageParams.get('guided') === '1';
  const explicitAssistantEntry = ['studio-assistant','global-assistant'].includes(pageParams.get('source')) || pageParams.get('assistant') === '1';
  const assistantAutoRequested = guidedRequested && (validGuidedValues || explicitAssistantEntry);
  if (guidedRequested && validGuidedValues) {
    setAssistantOpen(false);
    if (!pageParams.has('plan')) scheduleSharedAssistant({intent:'recommend',recommendation:guidedValues}, 180);
  } else {
    setAssistantOpen(false);
    if (assistantAutoRequested) {
      scheduleSharedAssistant({intent:'recommend'}, 180);
    }
  }
  if (aiPlanSeed) {
    assistantPlans = [aiPlanSeed];
    importAssistantPlan(aiPlanSeed);
  }
  syncAssistantComposer();
  render();
})();
